module.exports = __webpack_public_path__ + "static/media/icon_benefit_target.e2ce1693.svg";